function text(value){return String(value??'').trim();}

function optionalInteger(value,label){
  const raw=text(value);
  if(!raw)return null;
  const number=Number(raw);
  if(!Number.isInteger(number)||number<1)throw new TypeError(label+' must be a positive whole number');
  return number;
}

export function journalSessionTitleFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const title=text(formData.get('title'));
  if(title.length>160)throw new TypeError('Session title is too long');
  return title||null;
}

export function customProductInputFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const name=text(formData.get('customProductName'));
  if(!name)throw new TypeError('Custom product name is required');
  if(name.length>120)throw new TypeError('Custom product name is too long');
  const categoryKey=text(formData.get('customProductCategory')||'other').toLowerCase();
  return Object.freeze({name,categoryKey});
}

export function itemPreparationInputFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const curingMethodKey=text(formData.get('curingMethodKey'))||null;
  const curingMethodCustom=text(formData.get('curingMethodCustom'))||null;
  return Object.freeze({
    curingMethodKey,
    curingMethodCustom,
    curingDurationMinutes:optionalInteger(formData.get('curingDurationMinutes'),'curingDurationMinutes'),
    curingNotes:text(formData.get('curingNotes'))||null,
    marinadeNotes:text(formData.get('marinadeNotes'))||null,
    spicesNotes:text(formData.get('spicesNotes'))||null,
    dryingDurationMinutes:optionalInteger(formData.get('dryingDurationMinutes'),'dryingDurationMinutes'),
    dryingNotes:text(formData.get('dryingNotes'))||null,
    preparationDurationMinutes:optionalInteger(formData.get('preparationDurationMinutes'),'preparationDurationMinutes'),
    preparationNotes:text(formData.get('preparationNotes'))||null
  });
}

export function journalItemNoteTextFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const note=text(formData.get('itemNote'));
  if(note.length>4000)throw new TypeError('Journal item note is too long');
  return note;
}

export function journalNoteTextFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const note=text(formData.get('note'));
  if(note.length>4000)throw new TypeError('Journal note is too long');
  return note;
}

export function liveNoteInputFromForm(formData){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const note=text(formData.get('liveNote'));
  if(!note)throw new TypeError('Live note is required');
  if(note.length>4000)throw new TypeError('Live note is too long');
  const itemId=text(formData.get('liveNoteItemId'))||null;
  return Object.freeze({text:note,itemId});
}

export function journalPhotoInputFromFile(file,{sessionId,itemId=null,stageId=null,capturedAt=null}={}){
  if(!file)throw new TypeError('Photo file is required');
  const mimeType=text(file.type).toLowerCase();
  const sizeBytes=Number(file.size);
  const localPreviewUri=typeof URL!=='undefined'&&URL.createObjectURL
    ?URL.createObjectURL(file)
    :null;
  return Object.freeze({
    sessionId:text(sessionId),
    stageId:stageId?text(stageId):null,
    itemId:itemId?text(itemId):null,
    capturedAt:capturedAt?text(capturedAt):null,
    mimeType,
    sizeBytes,
    localPreviewUri
  });
}
